import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-mensualite',
    templateUrl: './mensualite.component.html',
    styleUrls: ['./mensualite.component.scss']
})
export class MensualiteComponent implements OnInit {
    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
